<template>
  <public-layout>
    <h3 v-bg-typography="'h2'">Forgot Password</h3>
    <transition name="fade">
      <form
        v-on:submit.prevent="resetPassword"
        :key="1"
        v-if="!(passwordIsSent || errorOccured)"
      >
        <p v-bg-typography="'m-body'">
          Enter your e-mail address below. We will send an e-mail within a few
          minutes with which a new password can be created.
        </p>
        <bg-field class="emailfield" label="E-mail address" name="email">
          <bg-input v-model="email" />
        </bg-field>
        <bg-button :isLoading="isLoading" type="submit" text="Send" />
      </form>
    </transition>
    <transition name="fade">
      <div :key="2" v-if="passwordIsSent">
        <p v-bg-typography="'m-body'">
          An email has been sent! You can use the link to create a new password.
        </p>
      </div>
    </transition>
    <transition name="fade">
      <div :key="3" v-if="errorOccured">
        <p v-bg-typography="'m-body'">{{ errorMessage }}</p>
      </div>
    </transition>
  </public-layout>
</template>

<style scoped>
.forgot-password {
  text-align: left;
}
.emailfield {
  width: 50%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-active {
  transition-delay: 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<script>
import PublicLayout from "@/layouts/public";
import BgTypography from "@/directives/bg-typography";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import BgButton from "@/components/bg-button";
import BgCheckbox from "@/components/bg-checkbox";

import API from "@/api";

export default {
  name: "signup",
  components: {
    BgButton,
    BgInput,
    BgField,
    BgCheckbox,
    PublicLayout,
  },
  directives: {
    BgTypography,
  },
  data: () => ({
    isLoading: false,
    passwordIsSent: false,
    errorOccured: false,
    errorMessage: "Alala",
    email: "",
  }),
  methods: {
    async resetPassword() {
      this.isLoading = true;
      const res = await API.user.forgotPassword(this.email);
      if (res.status === 400) {
        this.errorOccured = true;
        this.errorMessage = res.message;
      } else {
        this.passwordIsSent = true;
      }
    },
  },
};
</script>
